import { whatsappBaileysAPI } from '../services/api';

const STORAGE_KEY = 'whatsapp_usar_servicio';
const STORAGE_PROFILE_KEY = 'whatsapp_send_rate_profile';

/** true = Baileys/API; false = abrir wa.me */
export function readUseBaileysFromStorage() {
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === '0' || v === 'false') return false;
  return true;
}

export function writeUseBaileysToStorage(useBaileys) {
  localStorage.setItem(STORAGE_KEY, useBaileys ? '1' : '0');
}

export function readSendRateProfileFromStorage() {
  const v = localStorage.getItem(STORAGE_PROFILE_KEY);
  if (v === 'fast' || v === 'normal' || v === 'safe') return v;
  return 'normal';
}

export function writeSendRateProfileToStorage(profile) {
  localStorage.setItem(STORAGE_PROFILE_KEY, profile || 'normal');
}

const BATCH = 80;

/** Envío masivo rápido (sin pausas anti-bloqueo). Preferir sendWhatsAppSequential. */
export async function sendWhatsAppBatchChunks(items, sendBatch) {
  let ok = 0;
  let fail = 0;
  for (let i = 0; i < items.length; i += BATCH) {
    const slice = items.slice(i, i + BATCH);
    const data = await sendBatch(slice);
    const results = data.results || [];
    ok += results.filter((r) => r.success).length;
    fail += results.filter((r) => !r.success).length;
  }
  return { ok, fail, total: items.length };
}

/**
 * Envío uno a uno con perfiles anti-bloqueo (pausas, tope diario, backoff).
 * @param {Array<{phone,caption,documentBase64?,fileName?}>} items
 * @param {{ sendRateProfile?: string, onProgress?: (p) => void, shouldCancel?: () => boolean }} options
 */
export async function sendWhatsAppSequential(items, options = {}) {
  const profile = options.sendRateProfile || readSendRateProfileFromStorage();
  const batchId = `batch-${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
  let ok = 0;
  let fail = 0;
  let abortedEarly = false;
  let abortMessage = null;

  for (let i = 0; i < items.length; i++) {
    if (options.shouldCancel && options.shouldCancel()) {
      break;
    }

    if (options.onProgress) {
      options.onProgress({
        index: i,
        total: items.length,
        phase: `Preparando envío ${i + 1}/${items.length}…`,
      });
    }

    let data;
    try {
      data = await whatsappBaileysAPI.sendSequential({
        batchId,
        item: items[i],
        index: i,
        total: items.length,
        sendRateProfile: profile,
      });
    } catch (err) {
      const msg = err?.message || '';
      if (msg.includes('horario') || msg.includes('Horario')) {
        return {
          ok,
          fail: fail + (items.length - i),
          total: items.length,
          abortedEarly: true,
          abortMessage: msg,
          batchId,
          horarioBloqueado: true,
        };
      }
      throw err;
    }

    if (data.abortedEarly) {
      abortedEarly = true;
      abortMessage = data.abortMessage;
      if (data.success) ok++;
      else fail++;
      break;
    }

    if (data.success) ok++;
    else fail++;

    if (options.onProgress) {
      options.onProgress({
        index: i + 1,
        total: items.length,
        phase: data.throttleLabel || `Enviado ${i + 1}/${items.length}`,
        lastError: data.success ? null : data.error,
      });
    }
  }

  return { ok, fail, total: items.length, abortedEarly, abortMessage, batchId };
}

export function abrirWhatsappWeb(numeroSinMas, texto) {
  const url = `https://wa.me/${numeroSinMas}?text=${encodeURIComponent(texto)}`;
  window.open(url, '_blank');
}

export function abrirWhatsappWebEscalonado(destinatarios, delayMs = 1500) {
  destinatarios.forEach(({ numero, texto }, index) => {
    setTimeout(() => abrirWhatsappWeb(numero, texto), index * delayMs);
  });
}
